import React, { useMemo } from 'react'
import { IDetailCellRendererParams } from 'ag-grid-enterprise'
import { AgGridReact } from 'ag-grid-react'
import { useTranslation } from 'react-i18next'
import { Voucher, Transaction } from '../../../../pages/reporting/vouchers/types'
import agGridTheme from '../../../../config/agGrid/theme'
import { useAgGridLocale } from '../../../../shared/hooks/useAgGridLocale'
import { getTransactionColumnDefs } from './transactionColumnDefs'

const TransactionDetailRenderer: React.FC<IDetailCellRendererParams<Voucher>> = ({ data }) => {
  const { t } = useTranslation()
  const localeText = useAgGridLocale()

  const transactions = data?.transactions || []

  const columnDefs = useMemo(() => getTransactionColumnDefs(t, transactions), [t, transactions])

  if (transactions.length === 0) {
    return <div style={{ padding: '8px 16px', color: '#999' }}>{t('vouchersPage:noTransactions')}</div>
  }

  const maxRows = 10
  const visibleRows = Math.min(transactions.length, maxRows)
  const gridHeight = 59 + visibleRows * 24

  return (
    <div style={{ padding: '8px 16px', height: gridHeight }}>
      <AgGridReact<Transaction & { assetId?: number }>
        theme={agGridTheme}
        localeText={localeText}
        rowData={transactions}
        columnDefs={columnDefs}
        rowHeight={24}
        getRowId={params =>
          params.data.assetId ? `${params.data.assetId}-${params.data.type}` : String(params.data.id)
        }
        defaultColDef={{
          resizable: true,
          sortable: false,
          suppressHeaderMenuButton: true
        }}
      />
    </div>
  )
}

export default TransactionDetailRenderer
